module.exports = __webpack_public_path__ + "media/flowplayer_v7/flowplayer-8d207be99507f7744caae949aaa3b860.swf";